// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconHardwareDevicesHd_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 2H24V18H0V2ZM2 4H22V16H2V4Z" class="svg-bg"/>
  <path d="M16 20H8L7 22H17L16 20Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M17.4701 12.6773C18.1567 12.0639 18.5001 11.1539 18.5001 9.94727C18.5001 9.18727 18.3467 8.54727 18.0401 8.02727C17.7401 7.50727 17.3134 7.11393 16.7601 6.84727C16.2134 6.5806 15.5667 6.44727 14.8201 6.44727H12.5801V13.5873H14.6001C15.8267 13.5873 16.7834 13.2839 17.4701 12.6773ZM16.4101 8.24727C16.7567 8.6206 16.9301 9.2006 16.9301 9.98727C16.9301 11.5539 16.2001 12.3373 14.7401 12.3373H14.0901V7.68727H14.9001C15.5601 7.68727 16.0634 7.87393 16.4101 8.24727Z" class="svg-bg"/>
  <path d="M9.97754 13.5016H11.5596V6.49961H9.97754V9.29258H7.07715V6.49961H5.5V13.5016H7.07715V10.65H9.97754V13.5016Z" class="svg-bg"/>
</svg>
`;
/**
 * IconHardwareDevicesHd is a generated icon component.
 */
let IconHardwareDevicesHd = IconHardwareDevicesHd_1 = class IconHardwareDevicesHd extends IconBaseElement {
    render() {
        return html `${IconHardwareDevicesHd_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconHardwareDevicesHd.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconHardwareDevicesHd = IconHardwareDevicesHd_1 = __decorate([
    customElement('zui-icon-hardware-devices-hd')
], IconHardwareDevicesHd);
export { IconHardwareDevicesHd };
